import { render, staticRenderFns } from "./DataTableDeCrudPaginado.vue?vue&type=template&id=02150b74&"
import script from "./DataTableDeCrudPaginado.vue?vue&type=script&lang=ts&"
export * from "./DataTableDeCrudPaginado.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports